<template>
	<div class="public-mask">
		<div class="public-content">
			<div class="public-title">
				<span>SFHOWE123JO</span>
				<i class="el-icon-close" @click="closeMask"></i>
			</div>
			<div class="public-box">
				<div class="public-item">
					<div class="public-item-title">
						委托人信息
					</div>
					<div class="public-item-area">
						<div class="public-unit">
							<div class="key">
								委托机构：
							</div>
							<div class="value">
								{{entrust.organization}}
							</div>
						</div>
						<div class="public-unit">
							<div class="key">
								联系人：
							</div>
							<div class="value">
								{{entrust.concat}}
							</div>
						</div>
						<div class="public-unit">
							<div class="key">
								联系方式：
							</div>
							<div class="value">
								{{entrust.phone}}
							</div>
						</div>
						<div class="public-unit">
							<div class="key">
								委托人：
							</div>
							<div class="value">
								{{entrust.name}}
							</div>
						</div>
						<div class="public-unit-mid">
							<div class="key">
								地址：
							</div>
							<div class="value">
								{{entrust.address}}
							</div>
						</div>
						<div class="public-unit">
							<div class="key">
								被鉴定人：
							</div>
							<div class="value">
								{{entrust.obj}}
							</div>
						</div>
						<div class="public-unit-mid">
							<div class="key">
								证件号码：
							</div>
							<div class="value">
								{{entrust.code}}
							</div>
						</div>
					</div>
				</div>
				<div class="public-item">
					<div class="public-item-title">
						鉴定意见（必填）
					</div>
					<div class="public-item-area">
						<div class="public-textarea">
							<el-input type="textarea" :rows="3" placeholder="请输入鉴定意见" v-model="opinion">
							</el-input>
						</div>
					</div>
				</div>
				<div class="public-upload">
					<div class="public-upload-key">
						鉴定意见书：
					</div>
					<div class="public-upload-area">
						<el-upload class="upload-demo"
							:action="uploadSrc"
							:on-preview="handlePreview" :on-remove="handleRemove" :before-remove="beforeRemove" multiple
							:limit="3" :on-exceed="handleExceed" :file-list="fileList">
							<el-button size="small" type="primary">点击上传</el-button>
							<div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
						</el-upload>
					</div>
				</div>
				<div class="public-submit">
					<el-button type="success">提交委托</el-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'expertise',
		data() {
			return {
				entrust: {
					organization: '公安局',
					concat: '吉姆哈克',
					phone: '0311-82019999',
					name: '河北省石家庄市公安局XX分局',
					address: '甘肃省临夏回族自治州广河县阳光胡同488号',
					obj: '紫苑',
					code: '915001197612032727'
				},
				opinion: '',
				fileList: [{
					name: 'food.jpeg',
					url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
				}, {
					name: 'food2.jpeg',
					url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
				}],
				uploadSrc:'https://jsonplaceholder.typicode.com/posts/'
			};
		},
		methods: {
			closeMask() {
				this.$emit('closeExpertise')
			},
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			handlePreview(file) {
				console.log(file);
			},
			handleExceed(files, fileList) {
				this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${ file.name }？`);
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	@import url("../global.less");
</style>
